import { SearchApi } from './searchApi'

const API = () => {
  return {
    search: SearchApi()
  }
}

export { API }
